import { motion } from 'motion/react'

interface Props {
  children: React.ReactNode
  delay?: number
  duration?: number
  className?: string
  animateFrom?: 'left' | 'right' | 'top' | 'bottom'
}

export function FadeIn({
  children,
  duration = 0.6,
  animateFrom = 'bottom',
  delay = 0,
  className,
}: Props) {
  const translateY = animateFrom === 'top' ? -48 : animateFrom === 'bottom' ? 48 : 0
  const translateX = animateFrom === 'left' ? -48 : animateFrom === 'right' ? 48 : 0
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, translateX, translateY }}
      whileInView={{
        opacity: 1,
        translateX: 0,
        translateY: 0,
        transition: { duration, delay },
      }}
      viewport={{ once: true }}
    >
      {children}
    </motion.div>
  )
}
